// extracted by mini-css-extract-plugin
export var active = "_bn-7";
export var container = "_bn-0";
export var evenWidth = "_bn-4";
export var large = "_bn-5";
export var outlet = "_bn-8";
export var slide = "_bn-2";
export var small = "_bn-6";
export var tab = "_bn-3";
export var tabs = "_bn-1";